const loadChatView = () => import(/* webpackChunkName: "view-chat" */ '../view/Chat');
const loadFriendView = () => import(/* webpackChunkName: "view-friend" */ '../view/Friend');
const loadGroupView = () => import(/* webpackChunkName: "view-group" */ '../view/Group');

let chatViewPreloadPromise = null;

export function loadChatRouteView() {
	return loadChatView();
}

export function preloadChatRouteView() {
	if (!chatViewPreloadPromise) {
		chatViewPreloadPromise = loadChatView().catch((error) => {
			chatViewPreloadPromise = null;
			throw error;
		});
	}
	return chatViewPreloadPromise;
}

export function loadFriendRouteView() {
	return loadFriendView();
}

export function loadGroupRouteView() {
	return loadGroupView();
}
